import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const GoogleMap: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-amber-50/60 py-20">
      <div className="max-w-7xl mx-auto px-6">
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-yellow-600 font-semibold text-sm uppercase tracking-widest text-center mb-3"
      >
        {t("map.eyebrow")}
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="text-4xl font-bold mb-3 text-center text-black"
      >
        {t("map.title")}
      </motion.h2>
      <p className="text-gray-600 text-center mb-12 max-w-xl mx-auto">{t("map.subtitle")}</p>

      <div className="w-full h-[450px] md:h-[600px] rounded-2xl overflow-hidden shadow-lg border border-gray-100">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.29741869552!2d28.888712076530794!3d41.06249101608419!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab1dd435ce2d3%3A0x4213514acb6d2498!2zT2x5RGVudCBBxJ_EsXogdmUgRGnFnyBTYcSfbMSxxJ_EsSBLbGluacSfaSAtIEJheXJhbXBhxZ9h!5e0!3m2!1str!2str!4v1757729707084!5m2!1str!2str"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="OlyDent Konum"
        ></iframe>
      </div>
      </div>
    </section>
  );
};

export default GoogleMap;
